import axiosInstance from '../../../lib/api/axios';
import { getServerUrl } from '../../../lib/utils';
import { Role, UpdateRolePayload } from './types';

export const getRoleByIdOrSlug = async (id?: string) : Promise<Role> => {
  const { data } = await axiosInstance.get(`${getServerUrl()}/role/${id}`);
  return data;
};

export const getAllRoles = async () : Promise<Role[]> => {
  const { data } = await axiosInstance.get(`${getServerUrl()}/role`);
  return data;
};

export const updateRole = async (id: number, payload: UpdateRolePayload) : Promise<void> => {
  await axiosInstance.post(`${getServerUrl()}/accounts/${id}/actions/updateTargetAccountRole`, 
    { ...payload },
  );
  return;
};